module.exports = __webpack_public_path__ + "img/fire-extinguisher.6092ad1b.svg";